import React from 'react';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';
import classNames from 'classnames';

import { times } from 'lodash';

import { Button } from '@tcc/crate';

const baseString = 'vra-zone-product-application-input-keypad';
const classString = classNames({
  [`${baseString}`]: true
});
let ZoneProductApplicationInputKeypadContainer = ({
  onTapButton
}) => {
  const _buttonTextForType = (buttonType) => {
    if (buttonType === 'cancel') {
      return getMessage('button-text__cancel');
    } else if (buttonType === 'done') {
      return getMessage('button-text__done');
    } else if (buttonType === 'erase') {
      return ''; // An 'X' icon is displayed with CSS.
    } else {
      return buttonType; // This will be a single-digit # that doesn't need localization.
    }
  };

  let buttons = ['cancel','done','erase'].concat(times(10, (number) => number)).map((buttonType) => {
    const buttonClassString = classNames({
      [`${baseString}__button`]: true,
      [`${baseString}__button--number`]: typeof buttonType === 'number',
      [`${baseString}__button-${buttonType}`]: true
    });

    const buttonText = _buttonTextForType(buttonType);
    return (
      <Button
        className={buttonClassString}
        key={buttonType || 'close'}
        mode={ buttonType === 'cancel' || buttonType === 'done' ? 'link' : 'primary'}
        onClick={(e) => { onTapButton(e, buttonType); }}>
        {buttonText}
      </Button>
    );
  });
  const [ cancel, done, erase, zero ] = buttons.splice(0, 4);

  return (
    <section className={classString}>
      <header>
        {cancel}
        {done}
      </header>
      <section className={`${baseString}__body`}>
        {buttons}
        {zero}
        {erase}
      </section>
    </section>
  );
};

ZoneProductApplicationInputKeypadContainer.propTypes = {
  onChange: propTypes.func.isRequired,
  onClose: propTypes.func.isRequired,
  onTapButton: propTypes.func.isRequired
};

export default ZoneProductApplicationInputKeypadContainer;
